import { render, staticRenderFns } from "./newTeacher.vue?vue&type=template&id=ca4513b6&style=overflow%3Ahidden"
import script from "./newTeacher.vue?vue&type=script&lang=js"
export * from "./newTeacher.vue?vue&type=script&lang=js"
import style0 from "./newTeacher.vue?vue&type=style&index=0&id=ca4513b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports